import _extends from "@babel/runtime/helpers/esm/extends";
import { ELocale, EThemeKey } from '@lumahealthhq/ui-model-types';
import enUSMessagesVariant2UINext from '../messages-variant2/en-US/ui-next.json';
import esESMessagesUIComponents from '../messages/es-ES/ui-components.json';
import esESMessagesUINext from '../messages/es-ES/ui-next.json';
import ptBRMessagesUIComponents from '../messages/pt-BR/ui-components.json';
import ptBRMessagesUINext from '../messages/pt-BR/ui-next.json';
export default function getIntlMessages(locale, themeKey) {
  // Handle specific translations for variant2 (Banner)
  if (locale === ELocale.EnglishUS && themeKey === EThemeKey.Variant2) {
    return enUSMessagesVariant2UINext;
  }
  switch (locale) {
    case ELocale.SpanishUS:
      return _extends({}, esESMessagesUIComponents, esESMessagesUINext);
    case ELocale.PortugueseBR:
      return _extends({}, ptBRMessagesUIComponents, ptBRMessagesUINext);
    default:
      return {};
  }
}